import { Loader2 } from 'lucide-react'
import { Button } from '@/shared/ui/button'
import { useClientAccountOlderEvents } from '../hooks/use-client-account-older-events'
import type { ClientAccountDetailV2 } from '../services/client-accounts-admin-v2.service'
import { ClientAccountEventsList } from './client-account-events-list'

/**
 * La pestaña «Actividad»: la primera página que trae el detalle más lo que se vaya pidiendo
 * con «Ver más». Se monta con una `key` ligada a la primera página (ver el panel), para que un
 * detalle refrescado descarte las páginas viejas acumuladas en vez de mezclarlas.
 */
type ClientAccountActivityTabProps = {
  accountId: string
  events: ClientAccountDetailV2['events']
  pagination: ClientAccountDetailV2['eventsPagination']
}

export function ClientAccountActivityTab({
  accountId,
  events,
  pagination
}: ClientAccountActivityTabProps) {
  const { older, hasMore, isLoading, isError, loadMore } = useClientAccountOlderEvents(
    accountId,
    pagination
  )

  return (
    <div className="flex flex-col gap-3">
      <ClientAccountEventsList events={[...events, ...older]} />
      {isError ? (
        <p role="alert" className="text-xs text-destructive">
          No pudimos cargar más movimientos. Intenta de nuevo.
        </p>
      ) : null}
      {hasMore ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="self-start text-xs text-muted-foreground"
          disabled={isLoading}
          onClick={loadMore}
        >
          {isLoading ? <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden /> : null}
          Ver más
        </Button>
      ) : null}
    </div>
  )
}
